import React, { useContext } from 'react'
import ColorContext from '../../context/ColorContext'

const IncredibleSEO = ({ style }) => {
	const { color } = useContext(ColorContext)
	return (
		<svg
			id="svgIncredibleSEO"
			className="svgInline"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 225 152"
			style={style}
		>
			<linearGradient id="seoGradient" gradientUnits="userSpaceOnUse" x1="-3.3782" y1="152.3008" x2="231.5401" y2="-3.8886" gradientTransform="matrix(1 0 0 -1 0 151.2545)">
				<stop  offset="0" style={{ stopColor: color.bravo }} />
				<stop  offset="1" style={{ stopColor: color.alpha }} />
			</linearGradient>
			<path fill="url(#seoGradient)" d="M216.3 0H8.7C3.9 0 0 3.9 0 8.7v134.7c0 4.8 3.9 8.7 8.7 8.7h207.7c4.8 0 8.7-3.9 8.7-8.7V8.7c-.1-4.8-4-8.7-8.8-8.7zM204 10.4c0 1.8-1.4 3.2-3.2 3.2-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2c1.8 0 3.2 1.4 3.2 3.2zm-12.6 0c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2zm22-3.2c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2zm2.9 140.5H8.7c-2.4 0-4.3-2-4.3-4.3V18.6h216.3v124.7c0 2.4-2 4.4-4.4 4.4z" />
			<path fill="url(#seoGradient)" d="M14 29.5h30.5v50.2H14z" />
			<path fill="url(#seoGradient)" d="M101.6 87.2h26.7v50.2h-26.7z" />
			<path fill="url(#seoGradient)" d="M138.1 86.8H211V138h-72.9z" />
			<path fill="url(#seoGradient)" d="M55.3 29.5v30.4h62v9.2h-62v10.6h73V49.3h-62v-9.2h62V29.5h-62z" />
			<path fill="url(#seoGradient)" d="M80.8 86.8H14V138h77.8V86.8h-11zm0 40.5H25V97.4h55.9v29.9z" />
			<path fill="url(#seoGradient)" d="M138.1 29.5H211v10.6h-72.9z" />
			<path fill="url(#seoGradient)" d="M138.1 49.3H211v10.6h-72.9z" />
			<path fill="url(#seoGradient)" d="M138.1 69.1H211v10.6h-72.9z" />
		</svg>
	)
}

export default IncredibleSEO